import React from 'react';
import { Field } from 'react-final-form';
import { Error } from "./error";

const defaultAffiliations = [
  {label: "Batten School"},
  {label: "Arts and Sciences"},
  {label: "Curry School of Education"},
  {label: "Darden School of Business"},
  {label: "McIntire School of Commerce"},
  {label: "School of Architecture"},
  {label: "Engineering and Applied Sciences"},
  {label: "School of Law"},
  {label: "School of Medicine"},
  {label: "Continuing and Professional Studies"},
  {label: "School of Data Science"},
  {label: "School of Nursing"}
];

export function Affiliations(props) {
    const affiliations = props.affiliations || defaultAffiliations;
    const cells = affiliations.map((affiliation) =>
        <td>
            <label>
                <Field
                    name="affiliation"
                    component="input"
                    type="radio"
                    value={affiliation.label}
                    validate={props.validation}
                />{' '}
                {affiliation.label}
            </label>
        </td>
    )
    cells.push(
        <td>
            <label>
                <Field
                    name="affiliation"
                    component="input"
                    type="radio"
                    value="Other"
                    validate={props.validation}
                />{' '}
                {"Other "}
                <Field name="other_affiliation">
                    {({ input }) => (
                    <input {...input} type="text" />
                )}
                </Field>
            </label>
        </td>
    )
    const rows = []
    for (var i=0; i < cells.length; i += 2 ) {
        let row = (
        <tr key={`${i}`}>
            { cells[i] }
            { cells[i+1] ? cells[i+1] : null }
        </tr>)
        rows.push(row);
    }
    return (
    <div>
        <h3>School / Department Affiliation*</h3>
        <Error name="affiliation" />
        <table>
            <tbody>
                { rows }
            </tbody>
        </table>
    </div>);
}
